import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { requireUserLogin } from "../../routes/Auth";
import VerifyModal from "../../components/VerifyModal";
import LeftMenu from "../../components/LeftMenu";
import CustomTabs from "../../components/CustomTabs/CustomTabs";

import { PageRoute, VerifyModalI } from "../../models";
import { SingleChat } from "./SingleChat/SingleChat";
import { ChatsList } from "./ChatsList/ChatsList";
import SystemMessagesList from "./SystemMessages/SystemMessagesList";
import SystemMessageDetail from "./SystemMessages/SystemMessageDetail";
import { AD_ID_PARAM, INBOX_TYPE_PARAM, PAGE_PARAM, USER_ID_PARAM, TAB_PARAM, TAB_CHATS, TAB_SYSTEM } from "./constants/constants";
import { selectSystemMessageUnreadCount } from "../../routes/SystemMessage/systemMessage.ducks";
import { selectUnreadCount } from "../../routes/Chat/chat.ducks";
import styles from "./chatPage.scss";
import appStyles from "../App/app.scss";
import { getVerifyModalContent } from "../../services/getVerifyModalContent";

const ChatsPage = (props) => {
  const {
    user,
    location,
  } = props;

  const history = useHistory();
  const chatUnreadCount = useSelector(selectUnreadCount);
  const systemUnreadCount = useSelector(selectSystemMessageUnreadCount);
  const blankVerifyModal: VerifyModalI = { heading: "", content: "", redirectPath: "" };
  const [verifyModal, setVerifyModal] = useState(blankVerifyModal);

  const params = new URLSearchParams(location.search);
  const adId = params.get("adId");
  const chatId = params.get("chatId");
  const userParam = params.get(USER_ID_PARAM) || undefined;
  const adParam = params.get(AD_ID_PARAM) || undefined;

  const inboxType = params.get(INBOX_TYPE_PARAM);
  let inboxTypeParam = inboxType ? Number(inboxType) : undefined;
  if (!inboxType) {
    inboxTypeParam = undefined;
  } else if (inboxType === "null") {
    inboxTypeParam = null;
  } else {
    inboxTypeParam = Number(inboxType);
  }

  const pageRaw = params.get(PAGE_PARAM);
  const pageParam = pageRaw ? Number(pageRaw) : undefined;

  const messageId = params.get("messageId");
  const activeTab = params.get(TAB_PARAM) || TAB_CHATS;

  const handleTabChange = (key) => {
    const newParams = new URLSearchParams();
    newParams.set(TAB_PARAM, key);
    const search = newParams.toString();
    history.push({
      pathname: PageRoute.chats,
      search: search ? `?${search}` : "",
    });
  };

  const isSingleChat = adId || chatId;
  const isSingleSystemMessage = !!messageId;
  const hasFullProfile = user && user.isVerified && !user.hasInvalidUsername;

  const effectiveActiveTab = !hasFullProfile ? TAB_SYSTEM : activeTab;

  useEffect(() => {
    if (!hasFullProfile && (adId || chatId || activeTab === TAB_CHATS)) {
      setVerifyModal(getVerifyModalContent(user));
    }
  }, []);

  return (
    <React.Fragment>
      <LeftMenu activeKey={PageRoute.chats} showGoogleAd={false}>
        {hasFullProfile && isSingleChat ? (
          <SingleChat adId={adId} chatId={chatId} user={user} />
        ) : isSingleSystemMessage ? (
          <SystemMessageDetail messageId={messageId} />
        ) : (
          <div className={styles.tabsWrapper}>
            <CustomTabs
              activeKey={effectiveActiveTab}
              onChange={(key) => {
                if (!hasFullProfile && key === TAB_CHATS) {
                  setVerifyModal(getVerifyModalContent(user));
                  return;
                }
                handleTabChange(key);
              }}
              tabs={[
                {
                  key: TAB_CHATS,
                  label: (
                    <span className={styles.tabLabel}>
                      {chatUnreadCount > 0 && (
                        <span className={styles.unreadBadge}>{chatUnreadCount}</span>
                      )}
                      <span className={chatUnreadCount > 0 ? styles.tabLabelBold : undefined}>Razgovori</span>
                    </span>
                  ),
                  content: (
                    <ChatsList
                      user={user}
                      inboxTypeParam={inboxTypeParam}
                      userParam={userParam}
                      adParam={adParam}
                      pageParam={pageParam}
                    />
                  ),
                },
                {
                  key: TAB_SYSTEM,
                  label: (
                    <span className={styles.tabLabel}>
                      {systemUnreadCount > 0 && (
                        <span className={styles.unreadBadge}>{systemUnreadCount}</span>
                      )}
                      <span className={systemUnreadCount > 0 ? styles.tabLabelBold : undefined}>Sistemske poruke</span>
                    </span>
                  ),
                  content: <SystemMessagesList />,
                },
              ]}
            />
          </div>
        )}
      </LeftMenu>
      <VerifyModal
        visible={verifyModal.heading !== "" && verifyModal.content !== "" && verifyModal.redirectPath !== ""}
        onOk={() => {
          history.push(verifyModal.redirectPath);
          setVerifyModal(blankVerifyModal);
        }}
        onCancel={() => {
          setVerifyModal(blankVerifyModal);
        }}
        onClose={() => setVerifyModal(blankVerifyModal)}
        closable={false}
        className={appStyles.modal}
        {...verifyModal}
      />
    </React.Fragment>
  );
};

export default requireUserLogin(
  ChatsPage
);



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/ChatsPage.tsx